import { useEffect } from 'react'

import { EMPTY_OBJECT } from '../../../constants/common'
import { SUBMENU_DEFAULT_VALUE } from '../../../constants/route'
import { FilterBar } from '../../Filter'
import { Page, PageLoader } from '../../Page'
import { PageEmptyState } from '../../PageEmptyState'
import { PageHeader } from '../../PageHeader'
import { TablePagination } from '../../TablePagination'

function SearchResultsPage({
  EntityIcon,
  TableLayout,
  breadcrumbs,
  emptyText,
  filterEntity,
  isPerformingMassAction = false,
  layoutProps = EMPTY_OBJECT,
  qaName,
  searchQuery,
  shareEntity,
  sub = SUBMENU_DEFAULT_VALUE,
  tablePage,
}) {
  const {
    availableFilters,
    columns,
    filterValues,
    handleChangeShouldReloadFilters,
    handleLoadInit,
    handleReload,
    handleSetFilterValues,
    handleSetPagination,
    isLoading,
    isRefetching,
    items,
    ordering,
    pageScrollWrapperRef,
    pagination,
    requiredColumns,
    serverError,
    shouldReloadFilters,
  } = tablePage

  useEffect(() => {
    handleLoadInit()
  }, [])

  const isTableLoading = isLoading || isRefetching

  return columns && requiredColumns ? (
    <Page
      pagination={
        <TablePagination
          responsive
          isSkeleton={isLoading}
          value={pagination}
          onChange={handleSetPagination}
        />
      }
      qaName={qaName}
      scrollWrapperRef={pageScrollWrapperRef}
      serverError={serverError}
    >
      {isPerformingMassAction ? <PageLoader /> : null}
      <PageHeader
        breadcrumbs={breadcrumbs}
        isLoading={isLoading}
        itemsCount={pagination.count}
      />
      {filterEntity && (availableFilters?.length > 0 || isLoading) ? (
        <FilterBar
          responsive
          availableFilters={availableFilters}
          canViewFilterTemplate={false}
          entity={filterEntity}
          filterValues={filterValues}
          isSkeleton={isLoading}
          ordering={ordering}
          pagination={{ per_page: pagination.pageSize }}
          setFilterValues={handleSetFilterValues}
          shareBodyExtras={{ search_query: searchQuery }}
          shareEntity={shareEntity}
          shouldReloadValues={shouldReloadFilters}
          sub={sub}
          onChangeShouldReloadValues={handleChangeShouldReloadFilters}
          onReload={handleReload}
        />
      ) : null}
      <TableLayout
        {...layoutProps}
        emptyState={<PageEmptyState EntityIcon={EntityIcon} text={emptyText} />}
        hasTable={items?.items?.length > 0 || isTableLoading}
        tablePage={{ ...tablePage, isLoading: isTableLoading }}
      />
    </Page>
  ) : null
}

export default SearchResultsPage
